// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"81577e84","453":"fc7f24a6","455":"8c509c79"}[chunkId] + ".chunk.js";
};